/*jshint esversion: 6 */
import React, { useState, useEffect } from 'react';
import axios from "axios";
import HumanErrorGet from "./HumanErrorGet";
import HumanPreloader from "./HumanPreloader";
import {url_api_city} from "../ApiUrls";

function HumanCreateCity(props){
    "use strict";

    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [result, setResult] = useState([]);

    useEffect( () => {
        axios({
            method: "GET",
            url: url_api_city,
            responseType: 'json'
        })
        .then(response => {
            setResult(response.data.results);
            setIsLoaded(true);
        })
        .catch(function (error) {
            setIsLoaded(true);
            setError(error);
        });
    }, [props.update]);
    
    function ViewLabel(){
        return (
            <div
                className="profile__text-block d-flex justify-content-between align-items-baseline">
                <p className="profile__text">City</p>
                <img src="/static/img/error.svg" className="profile__error d-none" alt="" />
            </div>
        )
    };

    if (error) {
        return ( <div> {ViewLabel()} <HumanErrorGet error={error} /> </div> );
    } else if (!isLoaded) {
        return( <div> {ViewLabel()} <HumanPreloader /> </div> );
    } else {
        return (
            <div>
                {ViewLabel()}
                    <select name="city" id="city" className="profile__select"
                        form="profile"
                        onChange={(value) => {
                            props.selectCity(value.target.value);
                        }}>

                        <option key="0" value="0">Select City</option>
                        {result.map( t  =>
                            <option key={t.pk} value={t.pk}>({t.country?t.country.domen?t.country.domen:"":""}) {t.title}  -
                                {t.country?t.country.title?t.country.title:"":""} -
                                {t.timezone?t.timezone.timezone?t.timezone.timezone:"":""}</option>
                        )}
                    </select>
            </div>
        )
    }
}

export default HumanCreateCity;
